/**
 * Scott Sells Chevys - Site Config
 * --------------------------------
 * Scott: Replace the placeholders below with your real info.
 * All site copy reads from here.
 */
export const siteConfig = {
  brand: {
    name: "Scott Sells Chevys",
    tagline: "Central Ohio Vehicle Finder",
    mainTagline: "New and used vehicle help across Central Ohio.",
    secondaryTagline: "Live inventory. Personal help. A simpler way to find your next vehicle.",
  },
  scott: {
    fullName: "Scott Hall",
    phone: "614-535-8673",
    phoneTel: "tel:+16145358673",
    phoneSms: "sms:+16145358673",
    email: "askscott@scottsellschevys.com",
    emailMailto: "mailto:askscott@scottsellschevys.com",
    // Official photo of Scott — `c_pad,b_transparent` adds a transparent
    // safety margin so neither elbow sits flush against the image edge.
    photo:
      "https://res.cloudinary.com/diqi6ihgx/image/upload/c_pad,b_transparent,w_460,h_490,g_center/v1779989489/me_transparent_mhrj92.png",
    photoAlt: "Scott Hall — Scott Sells Chevys, Central Ohio vehicle consultant",
  },
  logo: {
    // Official Scott Sells Chevys logo (background removed)
    url: "https://res.cloudinary.com/diqi6ihgx/image/upload/v1779943524/scott_sells_chevys-removebg-preview_auwm6n.png",
    alt: "Scott Sells Chevys — Central Ohio Vehicle Finder",
  },
  dealership: {
    name: "DEALERSHIP_NAME_PLACEHOLDER",
    address: "DEALERSHIP_ADDRESS_PLACEHOLDER",
    cityStateZip: "Grove City, OH",
  },
  links: {
    facebook: "https://www.facebook.com/Scottsellschevrolets",
    instagram: "INSTAGRAM_URL_PLACEHOLDER",
    youtube: "YOUTUBE_URL_PLACEHOLDER",
    google: "GOOGLE_URL_PLACEHOLDER",
    financeApply: "https://www.byerschevy.com/finance/apply-for-financing/",
    accessories:
      "https://accessories.chevrolet.com/categories?bac=112811&eVar25=ACCYT3",
    siteDomain: "https://scottsellschevys.com",
    // Google Business review pages — primary CTA goes to Scott's personal
    // page; after the click, the customer is invited to also review on
    // Byers Chevrolet's Google page (optional, never required).
    scottReviewUrl: "https://g.page/r/CdfpZNrylTqkEBI/review",
    byersReviewUrl: "https://share.google/DezIHULEsn8ezS4el",
  },
  images: {
    dealership:
      "https://res.cloudinary.com/diqi6ihgx/image/upload/v1779942216/byers_aunmsh.avif",
    dealershipAlt: "Byers Chevrolet — Scott Hall's home dealership in Central Ohio",
  },
  analytics: {
    GA_MEASUREMENT_ID: "GA_MEASUREMENT_ID_PLACEHOLDER",
    GSC_VERIFICATION_CODE: "GSC_VERIFICATION_CODE_PLACEHOLDER",
    META_PIXEL_ID: "META_PIXEL_ID_PLACEHOLDER",
  },
  serviceAreaCities: [
    "Grove City",
    "Columbus",
    "Hilliard",
    "Dublin",
    "Gahanna",
    "Westerville",
    "Reynoldsburg",
    "Pickerington",
    "Groveport",
    "Canal Winchester",
    "Ashville",
    "Circleville",
    "London",
    "Plain City",
    "Delaware",
    "Marysville",
    "Pataskala",
    "Lancaster",
    "Chillicothe",
    "Newark",
  ],
  serviceAreaText:
    "Serving Grove City, Columbus, Hilliard, Dublin, Gahanna, Westerville, Reynoldsburg, Pickerington, Groveport, Canal Winchester, Ashville, Circleville, London, Plain City, Delaware, Marysville, Pataskala, Lancaster, Chillicothe, Newark, and surrounding Central Ohio communities within 50 miles.",
};

export const disclaimers = {
  sitewide:
    "Inventory, pricing, mileage, availability, photos, incentives, rebates, equipment, and payment information are subject to change and should be confirmed with the dealership. This website is intended as a personal sales and follow-up tool. Inventory data is provided through a read-only inventory feed.",
  payment:
    "Payment examples are estimates only and are not financing offers. Final terms depend on credit approval, lender programs, taxes, fees, down payment, trade value, payoff, and final vehicle price.",
  trade:
    "Online trade estimates are based on a wholesale-first dealer valuation model and are not a binding offer. Final value depends on in-person inspection, vehicle history, market conditions, payoff verification, and dealership appraisal.",
  byod:
    "Build My Own Deal is for planning and discussion only. It is not a final purchase agreement, finance approval, lease quote, or binding offer. Final pricing, taxes, fees, accessories, trade value, payoff, lender approval, vehicle availability, and payment terms must be confirmed with the dealership.",
  inventory:
    "Vehicle availability, pricing, mileage, equipment, and photos should be confirmed with the dealership.",
};

/** Required dealer fees shown on every vehicle detail page (per dealer spec). */
export const fees = {
  docFee: 398,
  titleFee: 50,
};

export const fmtMoney = (n) =>
  n === null || n === undefined
    ? ""
    : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const fmtMiles = (n) =>
  n === null || n === undefined
    ? ""
    : `${Number(n).toLocaleString("en-US")} mi`;
